import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  ConstructionDayReportType,
  RouterService,
  StateService,
  ToolService,
  WorkDay,
  WorkingEntry,
} from 'projects/shared/src/public-api';
import { ContextMenuOption } from '../../models/context-menu-option';

@Component({
  selector: 'lib-hours-detail',
  templateUrl: './hours-detail.component.html',
  styleUrls: ['./hours-detail.component.scss'],
  standalone: false,
})
export class HoursDetailComponent implements OnInit {
  user: string;
  date: string;
  id: string;
  workDay: WorkDay;

  constructor(
    public state: StateService,
    public route: ActivatedRoute,
    public tools: ToolService,
    public modalCtrl: ModalController,
    public routerService: RouterService
  ) {}

  ngOnInit() {
    this.state.workingDays$.subscribe((x) => {
      this.workDay = x.find((x) => x.id == this.id);
    });
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  editWorkDay() {
    this.modalCtrl.dismiss('edit', 'confirm');
  }

  async deleteWorkDay() {
    await this.state.deleteWorkDay(this.workDay);
    await this.modalCtrl.dismiss('delete', 'confirm');
  }

  async openContextMenu(event: MouseEvent, workEntry: WorkingEntry) {
    let additionalOptions: ContextMenuOption[] = [];
    if (
      this.state.userHasMinType(1) &&
      workEntry?.approvedBy == null &&
      !workEntry.createdByReport
    ) {
      additionalOptions.push({
        icon: 'time-outline',
        label: 'Arbeitszeitbericht erstellen',
        value: 'create-report',
      });
    }

    if (workEntry.createdByReport) {
      additionalOptions.push({
        icon: 'clipboard-outline',
        label: 'Bautagesbericht öffnen',
        value: 'open-report',
      });
    }

    const { data, role } = await this.state.openPopover(
      event,
      false,
      additionalOptions
    );
    if (!data) return;
    if (data == 'create-report') {
      await this.tools
        .showBasicAlert(
          'Aus der Arbeitszeit wird ein Arbeitszeitbericht erstellt. Den Bericht anschließend bestätigen?',
          'Erstellen und Bestätigen?',
          'Erstellen',
          'Erstellen und Bestätigen'
        )
        .then((x) => {
          if (x != 'backdrop') {
            let approve = x == 'Erstellen und Bestätigen';
            this.state.createReportByWorkEntry(
              workEntry.id,
              ConstructionDayReportType.$2,
              approve
            );
          }
        });
    } else if (data == 'open-report') {
      await this.openReport(workEntry);
    }
  }

  async openReport(workEntry: WorkingEntry) {
    if (workEntry.createdByReport) {
      await this.state.openConstructionDayReportDetailModal(
        workEntry.createdBy
      );
    }
  }
}
